<template>
  <data-form
    ref="form"
    v-model="value"
    :field-metas="metas"
    :only-key="false"
    :index="0"
    :describe="false"
    @syncData="handleSyncData"
  />
</template>

<script>
/* eslint-disable */
import DataForm from '@inv/components/metaData/form/view/data-form/'

const ENV = {
  PURE: true,
}

const relatedFilterURL = '/metadata/field/filter/'

const getMeta = apiName => [
  {
    key: 'relatedFilter',
    type: 'RANGE_CONDITION',
    innerName: 'relatedFilter',
    name: '筛选条件',
    scene: {
      max: 10,
      skipFormat: true,
      related_data_remote: `${relatedFilterURL}/${apiName}`,
      moduleInfoId: apiName,
      cNeedArray_object: true,
      validate: null,
      field_event_emit: [
        {
          event: 'change',
          script: (ctx, ...arg) => {
            return
            const { component } = ctx
            // if(component.value.length && component.value[0].filters[0].value!=="") {
            if (!component.value.length) {
              Object.assign(component.env.TITLE_RIGHT, {
                icon: 'icon-add',
                label: '添加筛选条件',
              })
            } else {
              if (
                component.value[0].filters[0] &&
                component.value[0].filters[0].value !== ''
              ) {
                Object.assign(component.env.TITLE_RIGHT, {
                  icon: 'icon-edit',
                  label: '编辑筛选条件',
                })
              } else {
                Object.assign(component.env.TITLE_RIGHT, {
                  icon: 'icon-add',
                  label: '添加筛选条件',
                })
              }
            }
          },
        },
      ],
      field_event_listen: [
        // {
        //   src: 'relatedDataFrom',
        //   event: 'change',
        //   script: async ({ component, args }) => {
        //     const { nv, ov, cache } = args[0]
        //     component.setValue([])
        //     if (!nv) {
        //       return
        //     }
        //     const obj = cache[nv]
        //     // let relatedApiName = extra.data.moduleInfoId === obj.objectDescribeApiName ? obj.targetApiName : obj.objectDescribeApiName;
        //     component.runtime_related_data_remote = `/metadata/field/filter/${apiName}`
        //   },
        // },
      ],
      asyncFormat: async ({ args: [value, moment, meta, component] }) => {
        return
        await this.$nextTick() // 等待 dom 异步更新
        const rows_index = Object.keys(component.$refs).reduce(
          (result, rows) => {
            if (
              _.startsWith(rows, 'rows') &&
              !_.isEqual(component.$refs[rows], [])
            ) {
              result.push(component.$refs[rows])
            }
            return result
          },
          [],
        )

        if (
          !rows_index.length ||
          !value.length ||
          value[0].filters[0].value === ''
        ) {
          return ''
        }

        let condition_index = rows_index.reduce((res, rows, i) => {
          let condition = rows.reduce((result, row, index) => {
            let { a, b, c } = row.$refs
            if (!a || !a.skin || !b || !b.skin || !c) {
              return result
            }
            let field = a.skin.label
            let relation = b.skin.label
            let val = c.skin
            result.push(
              `<div class="view-search_condition">
              <div class="view-search_condition-index">${index + 1}</div>
              <div class="view-search_condition-main">
                <div class="view-search_condition-item">${field}</div>
                <div style="line-height: 22px;">${relation}</div>
                ${
                  val && val !== '-'
                    ? `<div class="view-search_condition-item">${val}</div>`
                    : ''
                }
              </div>
            </div>`,
            )

            return result
          }, [])

          res.push(
            `<div class="view-range_condition" style="width: 245px">
            <div class="view-range_condition-title">
              <i class="icon iconfont icon-drag range-icon"></i>
              <span class="condition-title">组内关系: ${kr.formatMd.formatConnector(
                value[i].connector,
              )}</span>
            </div>
            <div class="view-range_condition-item">
              ${condition.join('')}
            </div>
            ${
              value.length === i + 1
                ? ''
                : `<div class="view-range_condition-relation" v-show="${value.length !==
                    i + 1}">
              <span>${kr.formatMd.formatConnector(
                value[i].filterConnector,
              )}</span>
            </div>`
            }
          </div>`,
          )

          return res
        }, [])

        return condition_index.join('')
      },
    },
    env: {
      READONLY: true,
      TITLE_RIGHT: {
        icon: 'icon-add',
        label: '添加筛选条件',
        handle: `
        const {component} = ctx;
        let func = function(v) {
          component.setValue(v);
        };
        return {
          func: func,
          key: 'relatedFilter',
          value: component.value
        };
        `,
        prepare: null,
      },
    },
    unVisible: false,
  },
]

export default {
  name: 'ConditionRow',
  props: {
    apiName: String,
  },
  data() {
    return {
      ENV,
      metas: getMeta(this.apiName),
      value: {
        type: 2,
      },
    }
  },
  watch: {
    apiName(n, o) {
      if (n !== o) {
        this.handleUpdateMetas(n)
      }
    },
  },
  components: {
    DataForm,
  },
  methods: {
    async handleUpdateMetas(apiName) {
      this.metas = []
      await this.$nextTick()
      this.metas = getMeta(apiName)
    },
    handleGetValue() {
      const formData = this.$refs.form.submit()
      return formData
    },
    handleSyncData(value) {
      this.$emit('updateData', value)
    },
  },
}
</script>
